import { render, staticRenderFns } from "./DisplayReports.vue?vue&type=template&id=01b72886"
import script from "./DisplayReports.vue?vue&type=script&lang=ts"
export * from "./DisplayReports.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports